import 'whatwg-fetch'
import fetchival from 'fetchival'
import {loggedIn, getUserAccessToken} from './auth'

const prefix = '/api';

export default (url, fetchOpts = {}) => {
	if (loggedIn()) {
		fetchOpts.headers = Object.assign({},
			fetchOpts.headers,
			{'Access-Token': getUserAccessToken()}
		)
	}

	return fetchival(prefix + url, fetchOpts)
}
